import { cn, isCertifPending } from '@/lib/utils';
import { VerifStatusEnum } from '@/lib/enum';
import { Loader } from 'lucide-react';
import { Badge } from '../ui';

type TProps = {
  mode: 'banner' | 'loader';
  forceDisplay?: boolean;
  size?: string | number;
  className?: string;
  user?: {
    verifications?: {
      id?: {
        status: VerifStatusEnum;
      };
    };
  };
}

const BadgeUserPendingCertification = ({ user, className, forceDisplay, mode, size = 20 }: TProps) => {

  if (!forceDisplay && !isCertifPending(user?.verifications)) {
    return <></>;
  }

  if (mode === 'banner') {
    return (
      <Badge
        variant={'secondary'}
        className={cn(
          'bg-purple-600 text-white px-1.5 py-0.5 text-xs rounded-sm rounded-r-none',
          'hover:bg-purple-600',
          className
        )}>
        Certif. en cours...
      </Badge>
    );
  }

  return (
    <Loader
      size={size}
      color='#9333ea'
      className={cn(className, 'animate-spin')} />
  );

};

export default BadgeUserPendingCertification;
